import { z } from "zod";

export const InsightType = {
	MAX_VALUE: "max_value",
	MIN_VALUE: "min_value",
	TREND: "trend",
	OUTLIER: "outlier",
	SUMMARY: "summary",
} as const;
export type InsightType = (typeof InsightType)[keyof typeof InsightType];

export const chartInsightSchema = z.object({
	type: z.enum(InsightType),
	message: z.string().min(1),
	value: z.union([z.string(), z.number()]).nullable(),
});

export type ChartInsight = z.infer<typeof chartInsightSchema>;
